<template>
  <div class="animated fadeIn">     
    <b-row>
      <b-col md="12">
<!--          <b-breadcrumb :items="breadcrumbs"/>       
 -->        <b-card>
          <div slot="header">
            <strong>Zone Master</strong>
            <div class="card-header-actions" >                
              <button class="btn btn-sm btn-primary mr-4 btn-pill" v-on:click="zoneadd()"  type="button">Add New Zone</button> 
            <router-link
        to="/pincodes"
      > <button class="btn btn-sm btn-primary mr-4 btn-pill"   type="button"> Available Pin Codes</button> </router-link>
                           <router-link
        to="/zonenames"
      > <button class="btn btn-sm btn-primary mr-4 btn-pill"   type="button">Available Zones</button> </router-link> 
                <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button> 
            </div>
          </div>

         
          <div id="addzone"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;" class="mb-1">
              <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                <b-row> 
                  <b-col md="12">
                    <div class="form-group row">
                       <label class="col-md-3 col-form-label" for="hf-email">Zone Name</label>
                      <div class="col-md-4">
                        <b-form-input class="form-control" type="text" name="zoneno" v-model="zoneno" v-validate="'required|'"placeholder="Enter Zone Name" :class="{'input': true, 'text-danger': errors.has('form-1.zoneno') }"  >
                       </b-form-input>
                       <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('zoneno')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.zoneno')" class="help text-danger">{{ errors.first('form-1.zoneno') }}</span>
                      </b-input-group>
                      </div>
                
                    </div>   

                    <div class="form-group row">

                     

                  <label class="col-md-3 col-form-label" for="hf-email">Add  Pin Codes</label>
                 
                <vue-tags-input
                      v-model="customer.pincodelisting" 
                    :tags="tags2"

  
                    @tags-changed="newTags => tags2 = newTags  "
                    ref="taginput"
                    v-bind:separators="[',', ';']"

                   
                   />
                   <span v-show="errors.has('form-1.pincodelisting')" class="help text-danger">{{ errors.first('form-1.pincodelisting') }}</span>
                
                  
                      </div>
                                          
                  </b-col>
                
                  <b-col sm="2">
                    <b-button variant="primary" size="md" type="submit">Save</b-button>
                  </b-col>
                </b-row>  
              </b-form>
          </div>
          
               <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col>  
          <b-table show-empty stacked="md"  :items="items" :busy="isBusy"  :fields="fields1"  :current-page="currentPage"   :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  
            <template slot="actions" slot-scope="row">
             
                 <b-button size="sm" @click="editinfoModal(row.item)" class="mr-1">
                    Edit
                  </b-button>
                
                </template>

        
          </b-table>
          <b-modal title="Update Pin Codes " v-model="editAgentMaster" @ok="editAgentMaster = false">
          <template slot="modal-header" slot-scope="{ close }">
          <h5>Update Pin Codes</h5>
          </template>
          <template slot="default" slot-scope="{ hide }">
             <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5">
                <b-form-group
                  label="Zone Name"
                  :label-cols="3" >
                  <b-form-input readonly type="text" name="Zone Name" maxlength="10" v-model="customer.zonename" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-5.mobile number') }" placeholder="Enter Zone Name">
                  </b-form-input>
                  <span style="width:240px" v-show="errors.has('form-5.mobile number')" class="help text-danger">{{ errors.first('form-5.Zone Name') }}</span>                 
                </b-form-group>
              

                  <b-form-group label=" UID Not Having Shipments"  :label-cols="4" >
                 
                <vue-tags-input
                      v-model="customer.pincodelist" 
                    :tags="tags"

  
                    @tags-changed="newTags => tags = newTags  "
                    ref="taginput"
                    v-bind:separators="[',', ';']"

                   
                   />
                   <span v-show="errors.has('form-1.pincodelist')" class="help text-danger">{{ errors.first('form-1.pincodelist') }}</span>
                  </b-form-group> 

                    <b-form-group label=" UID Having Shipments"  :label-cols="3" >
                                         
                              <b-form-textarea
                              id="textarea"
                              v-model="texts"
                            readonly
                              rows="3"
                              max-rows="6"
                              ></b-form-textarea> 
                   <span v-show="errors.has('form-1.textarea')" class="help text-danger">{{ errors.first('form-1.textarea') }}</span>
                  </b-form-group> 
                  
              
               

                     

                 
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button>
                  <b-button  size="sm" variant="danger" @click="editcancel(); pincodes();">cancel</b-button>
                </div>
              </b-form>
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
      </b-modal> 

          <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>    
        </b-card>
       
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  name: 'zonemaster', 
  data: function() {
    return {
      name: 'zonemaster',
      isBusy: false,
      breadcrumbs: [{
        text: 'Dashboard',
        href: '/dashboard'
      },{
        text: 'Zone Master',
        active: true
      }],
      add: true,
               
       items:[],
       shipments:[],
       noshipments:[],
     
     fields1: [
          { key: 'zone_name', label: 'Zone Name', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'pincodes', label: 'Pin Codes', sortable: true,tdClass: 'nameOfTheClass'},
          { key: 'actions', label: 'Actions' ,tdClass: 'nameOfTheClass'},
         
        
       ], 
        bordered: true,
        totalRows: 0,
        showSelectAll : true,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        options:[],
        fields: { text: 'name', value: 'id' },
        zoneno:'',
        value2:[],
        tags:[],
        tags1:[],
        tags2:[],
         texts: [],
        pincodelist:[],
        pincodeoptions:[],
        sortDesc: false,
        allowCustomValue : true,
        sortDirection: 'desc',
        filter: null,
        customer:{},

        editAgentMaster:false,
        
    }
  },
  created: function() { 
    this.pincodes(); 
    this.displaydata();
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
   
  },
  computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  methods: {
     
    validateForm(scope) {
       this.$validator.validateAll(scope).then(result => {
        if (result) {          
          this.addZoneInfo();
        }
      });
    },
    
    zoneadd: function() {
      this.errors.clear("form-1");
   
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var addzone = document.getElementById("addzone");
      addzone.style.display = "block";
    
    },
     addZoneInfo: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var pincodelistingarr=[];
       for(var i = 0; i < this.tags2.length; i++) {
          pincodelistingarr.push(this.tags2[i].text);  
       }
      
       //this.$router.push('/addridersinglepage');

     const pincodesave = {
                
                
                 zone_name:this.zoneno,
                 pincode:pincodelistingarr,
                 hub_id: `${userInfo.pickuplocationmasterid.toString()}`,
                 
                 
 }
              // console.log(pincodesave);
    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/updatepincodetozone`,pincodesave)
        .then((result) => {
         if (result.body.returnmsg === "Successful") {
                 Utils.notify("Added successfully", "success");

                 
                  this.clear();
                 
                  this.displaydata();
                  this.$router.push('/zonemaster');
                } else {
            Utils.notify(result.body.returnvalue);
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
      
    },
       pincodes: function() {
        //alert(" i m in pin codes");
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
          
          const Obj = {
         
           hub_id: `${userInfo.pickuplocationmasterid.toString()}`,
            
           
          };
     
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/pincodelistingfornullzone`,Obj)
        .then((result) => {
          this.pincodelist  = result.body.returnvalue
                 for(var i = 0; i < this.pincodelist.length; i++) {
            var pins = {
        name: this.pincodelist[i].mapping_locality_id,
         id: this.pincodelist[i].mapping_locality_id,
       
      }
 this.pincodeoptions.push(pins);
       
           
       }

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
    validateForm5(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
           this.updatepincodes();
        }
      });
    },
    updatepincodes: function() {
    // console.log(this.texts[0]) 
  // alert("Update");   
    // console.log(this.customer.zonename);
    // console.log(this.tags);

    //  var pincodelistarr=[];
    //    for(var i = 0; i < this.tags.length; i++) {
    //     console.log("val:"+this.tags[i]);
    //       pincodelistarr.push(this.tags[i]);  
    //    }
    var pincodelistarr=[];
       for(var i = 0; i < this.tags.length; i++) {
    if(this.tags[i].text== null || this.tags[i].text=="undefined" || this.tags[i].text=="")
        {
           pincodelistarr.push(this.tags[i]);
          

        }
          else
          {
             pincodelistarr.push(this.tags[i].text);
            
          }
        // console.log("val"+this.tags[i]);
            
       }
     for(var i = 0; i < this.texts.length; i++) {

     pincodelistarr.push(this.texts[i]);
   }
    
      var Obj = {
          zonename : this.customer.zonename,
          pincodes : pincodelistarr,
         
            
      
      };  
       // console.log(Obj);
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/editpincodestozone`,
            Obj
          ).then(result => {
             if (result.body.returnmsg === "Successful") {
            alert("updated successfully");
            this.editAgentMaster = false;
            this.customer = {};

            this.displaydata();
             this.tags=[];
              this.$router.push('/zonemaster');
            }
            else if (result.body.returnmsg === "Unsuccessful") {
            Utils.notify(result.body.returnvalue);
            // this.displaydata();
            //  this.tags=[];
            //   this.$router.push('/zonemaster');
          }
          else
          {
           Utils.notify(result.body.returnvalue); 
          }
          })
          .catch(ex => {
            console.log("error", ex);
          });

                
      
    }, 
     editinfoModal: function(value) {
      //alert(value.pincodes);
      //alert(" i m in info model");
       
     if(value.pincodes ==null)
     {
         var Obj = {
          zonename : value.zone_name,
          pincodes : value.pincodes,
         
            
      
      };  
    
     
     }
      
      else
      {
     
         var Obj = {
          zonename : value.zone_name,
          pincodes : value.pincodes.split( ","),
         
            
      
      };  
    }

       //console.log(Obj);

         this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/pincodeshavingshipments`,Obj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
             
             this.noshipments  = result.body.returnvalue[0];
             //console.log(this.noshipments.UID_Having_NO_Shipments.length);
                var noshipmentarr=[];
             for(var i = 0; i < this.noshipments.UID_Having_NO_Shipments.length; i++) {
             //console.log(this.noshipments.UID_Having_NO_Shipments[i].mapping_locality_id);
             noshipmentarr.push(this.noshipments.UID_Having_NO_Shipments[i].mapping_locality_id);

           }  
           this.tags=noshipmentarr;

           this.shipments  = result.body.returnvalue[1];
             //console.log(this.noshipments.UID_Having_Shipments.length);
                var shipmentarr=[];
             for(var i = 0; i < this.shipments.UID_Having_Shipments.length; i++) {
             //console.log(this.noshipments.UID_Having_Shipments[i].mapping_locality_id);
             shipmentarr.push(this.shipments.UID_Having_Shipments[i].mapping_locality_id);

           }  
           this.tags=noshipmentarr;
           this.texts=shipmentarr;

           //console.log("mukesh"+noshipmentarr);
           
             
           
     
       // console.log(noshipmentarr);
             //this.shipments  = result.body.returnvalue[1].UID_Having_Shipments;
            
            // console.log(this.shipments);
           
          } else {
            this.tags=[];
           this.texts=[];
            
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    
      
      this.customer.zonename = value.zone_name;
      
      // console.log(this.customer.zonename);
    


     
    
      this.editAgentMaster = true;
      
      
    },
    editcancel: function() {
        this.tags=[];
      this.customer = {};
      this.editAgentMaster = !this.editAgentMaster;
      
    },
    refresh:function() {
     
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var addzone = document.getElementById("addzone");
      addzone.style.display = "none";
      this.clear();
    },
   
    
    displaydata: function () {

      //alert("zone & pin codes");
    this.isBusy = true;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
        
        const obj = {
                
                
               
                 hub_id: `${userInfo.pickuplocationmasterid.toString()}`,
                 
                 
 }
      

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/displayzoneandpincodes`,obj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
             this.items  = result.body.returnvalue;
             // console.log(this.items);
             this.totalRows = result.body.returnvalue.length;
             this.isBusy = !this.isBusy;
          } else {
            this.items=[];
            this.totalRows =0;
               this.isBusy = !this.isBusy;
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    
     
    clear: function() {
      this.zoneno = '';
       this.tags2=[];
      this.errors.clear('form-1')    
    }    
    
  }
 
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  .nameOfTheClass {
   max-width: 450px;
}
.ti-new-tag-input-wrapper input[data-v-61d92e31] {
    flex: 1 0 auto;
    min-width: 310px;
    border: none;
    padding: 0px;
    margin: 0px;
}
</style>
